import { useEffect, useRef } from "react";

const WHATSAPP_URL = "https://wa.me/5512991220961?text=Olá,%20sou%20empresário%20e%20gostaria%20de%20falar%20com%20um%20especialista.";

const SERVICES = [
  {
    icon: "ri-building-4-line",
    title: "Consultoria Jurídica Preventiva",
    desc: "Identificamos e mitigamos riscos antes que se tornem problemas, garantindo segurança jurídica para o seu negócio.",
  },
  {
    icon: "ri-team-line",
    title: "Direito do Trabalho Empresarial",
    desc: "Orientação estratégica em relações de trabalho, redução de passivos trabalhistas e defesa em ações judiciais.",
  },
  {
    icon: "ri-government-line",
    title: "Direito Previdenciário Empresarial",
    desc: "Planejamento e gestão de obrigações previdenciárias para empresas, minimizando riscos e otimizando contribuições.",
  },
  {
    icon: "ri-briefcase-4-line",
    title: "Direito Empresarial",
    desc: "Constituição de empresas, contratos, fusões, aquisições e toda a estrutura jurídica do seu negócio.",
  },
  {
    icon: "ri-scales-3-line",
    title: "Contencioso Estratégico",
    desc: "Representação jurídica em litígios empresariais com estratégia sólida e foco em resultados favoráveis.",
  },
];

export default function EmpresasSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll(".reveal-emp");
            items.forEach((item, i) => {
              setTimeout(() => {
                item.classList.add("opacity-100", "translate-y-0");
                item.classList.remove("opacity-0", "translate-y-8");
              }, i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="empresas" ref={sectionRef} className="py-24 lg:py-32 bg-grafite relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-rose-primary/10 rounded-full -translate-y-1/2 translate-x-1/3 blur-3xl" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-rose-primary/5 rounded-full translate-y-1/2 -translate-x-1/4 blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="reveal-emp opacity-0 translate-y-8 transition-all duration-700 flex items-center justify-center gap-3 mb-6">
            <div className="h-px w-10 bg-rose-light" />
            <span className="text-rose-light text-xs font-medium uppercase tracking-widest">Para Empresas</span>
            <div className="h-px w-10 bg-rose-light" />
          </div>
          <h2 className="reveal-emp opacity-0 translate-y-8 transition-all duration-700 font-heading text-4xl lg:text-5xl text-white font-semibold leading-tight mb-4">
            Proteção jurídica para o<br />crescimento do seu negócio
          </h2>
          <p className="reveal-emp opacity-0 translate-y-8 transition-all duration-700 text-white/60 text-base max-w-xl mx-auto">
            Oferecemos assessoria jurídica completa para empresas, desde a prevenção de riscos até a defesa estratégica em litígios.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {SERVICES.map((service, idx) => (
            <div
              key={service.title}
              className={`reveal-emp opacity-0 translate-y-8 transition-all duration-700 group p-7 rounded-xl border border-white/10 hover:border-rose-primary/50 hover:bg-rose-primary/10 transition-all cursor-default ${idx === 4 ? "md:col-span-2 lg:col-span-1" : ""}`}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-rose-primary/20 rounded-xl mb-5 group-hover:bg-rose-primary/30 transition-colors">
                <i className={`${service.icon} text-rose-light text-xl`} />
              </div>
              <h3 className="text-white font-semibold text-base mb-3">{service.title}</h3>
              <p className="text-white/55 text-sm leading-relaxed">{service.desc}</p>
            </div>
          ))}
          {/* Image card */}
          <div className="reveal-emp opacity-0 translate-y-8 transition-all duration-700 rounded-xl overflow-hidden h-56 lg:h-auto relative">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20corporate%20business%20team%20meeting%20boardroom%20professional%20executives%20handshake%20sophisticated%20dark%20interior%20warm%20ambient%20lighting%20premium%20corporate&width=600&height=400&seq=empresa1&orientation=landscape"
              alt="Assessoria jurídica empresarial advogado trabalhista"
              title="Consultoria jurídica empresarial – SM Advogados"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-grafite/60 to-transparent" />
          </div>
        </div>

        {/* CTA */}
        <div className="reveal-emp opacity-0 translate-y-8 transition-all duration-700 text-center">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-rose-primary hover:bg-rose-dark text-white font-medium px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-base" />
            </div>
            Falar com Especialista Empresarial
          </a>
        </div>
      </div>
    </section>
  );
}
